import React, { useState } from "react";
import Divider from "@material-ui/core/Divider";
import { Box, Popover } from "@material-ui/core";
import styles from "./AddSubAssemblyForm.module.css";
import { Button } from "../../atomicComponents";
import clsx from "clsx";
import CustomSelect from "../FormComponents/CustomSelect";
import { MESSAGE_TYPE } from "../../constants";
import { addSubAssemblyConfiguration } from "../../apis/calls";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";

const AddSubAssemblyForm = ({ open, closeFormPopup, handleClose: propHandleClose, plant, line, onSuccess }) => {
  const [subAssemblyName, setSubAssemblyName] = useState("");
  const [readyForDropFlag, setReadyForDropFlag] = useState({ value: true, label: "Yes" });
  const [dropStartSeq, setDropStartSeq] = useState("");
  const [dropEndSeq, setDropEndSeq] = useState("");

  const { showPopup, showError } = usePopupManager();

  const closeForm = () => {
    if (closeFormPopup) closeFormPopup();
    if (propHandleClose) propHandleClose();
  };

  const readyForDropOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  const resetState = () => {
    setSubAssemblyName("");
    setReadyForDropFlag({ value: true, label: "Yes" });
    setDropStartSeq("");
    setDropEndSeq("");
  };

  const formSubmit = async () => {
    if (!subAssemblyName || dropStartSeq === "" || dropEndSeq === "") {
      showError({
        contextText: "Validation Error",
        info: "All fields are mandatory. Please fill in all fields.",
      });
      return;
    }

    if (Number(dropEndSeq) < Number(dropStartSeq)) {
      showError({
        contextText: "Validation Error",
        info: "Drop End Seq must be greater than or equal to Drop Start Seq.",
      });
      return;
    }

    try {
      const payload = {
        subAssemblyName: subAssemblyName,
        readyForDropFlag: readyForDropFlag.value,
        dropStartSeq: Number(dropStartSeq),
        dropEndSeq: Number(dropEndSeq),
      };

      await addSubAssemblyConfiguration(plant.value, line.value, payload);

      showPopup({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: "Sub Assembly Configuration added successfully.",
        info: `Sub Assembly: ${subAssemblyName}`,
      });

      resetState();
      closeForm();

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      showPopup({
        type: MESSAGE_TYPE.FAILURE,
        contextText: "Sub Assembly Configuration addition failed.",
        info: error?.response?.data?.errors?.[0] || "Please try again or contact support.",
        error: error,
      });
    }
  };

  const handleClose = () => {
    resetState();
    closeForm();
  };

  const handleSeqChange = (setter) => (e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) {
      setter(val);
    }
  };

  return (
    <>
      <Popover
        open={open}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        className={styles.popoverBck}
      >
        <form className={styles.formBox}>
          <div className={styles.formTitleNew}>
            <span className={styles.formTitle}>Sub Assembly Configuration</span>
            <div className={styles.formlLineDiv} />
          </div>
          <Box
            bgcolor="#dadada3d"
            paddingTop="14px"
            paddingBottom="14px"
            borderRadius="6px"
          >
            <span className={styles.titlespan}>Plant</span>
            <span
              style={{ display: "inline", marginLeft: "100px" }}
              className={styles.formSubTitle}
            >
              <input
                type="text"
                className={clsx(styles.textInput, styles.disabledInput)}
                value={plant?.label || plant?.value || ""}
                disabled
              />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="14px">
            <span className={styles.titlespan}>Line</span>
            <span
              style={{ display: "inline", marginLeft: "108px" }}
              className={styles.formSubTitle}
            >
              <input
                type="text"
                className={clsx(styles.textInput, styles.disabledInput)}
                value={line?.label || line?.value || ""}
                disabled
              />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="14px">
            <span className={styles.titlespan}>Sub Assembly Name</span>
            <span
              style={{ display: "inline", marginLeft: "18px" }}
              className={styles.formSubTitle}
            >
              <input
                type="text"
                className={styles.textInput}
                value={subAssemblyName}
                onChange={(e) => setSubAssemblyName(e.target.value)}
                placeholder="Enter name"
              />
            </span>
          </Box>
          <Divider className={styles.partitionLine} />
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="14px">
            <span className={styles.titlespan}>Ready For Drop</span>
            <span
              style={{ display: "inline", marginLeft: "30px" }}
              className={styles.formSubTitle}
            >
              <CustomSelect
                name="ReadyForDrop"
                isMandatory
                options={readyForDropOptions}
                className={clsx(styles.dropDownSelect, styles.sel1)}
                value={readyForDropFlag}
                onChange={(option) => setReadyForDropFlag(option)}
                maxMenuHeight={200}
              />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="14px">
            <span className={styles.titlespan}>Drop Start Seq</span>
            <span
              style={{ display: "inline", marginLeft: "36px" }}
              className={styles.formSubTitle}
            >
              <input
                type="text"
                className={styles.textInput}
                value={dropStartSeq}
                onChange={handleSeqChange(setDropStartSeq)}
                placeholder="Enter start seq"
              />
            </span>
          </Box>
          <Box bgcolor="#dadada3d" paddingTop="14px" paddingBottom="20px">
            <span className={styles.titlespan}>Drop End Seq</span>
            <span
              style={{ display: "inline", marginLeft: "44px" }}
              className={styles.formSubTitle}
            >
              <input
                type="text"
                className={styles.textInput}
                value={dropEndSeq}
                onChange={handleSeqChange(setDropEndSeq)}
                placeholder="Enter end seq"
              />
            </span>
          </Box>
          <div style={{ float: "right" }}>
            <Button
              variant="primary"
              className={clsx(styles.button, styles.confirmButton)}
              type="button"
              onClick={formSubmit}
            >
              CONFIRM
            </Button>
            <Button
              className={clsx(styles.button, styles.cancelButton)}
              onClick={handleClose}
            >
              CANCEL
            </Button>
          </div>
        </form>
      </Popover>
    </>
  );
};

export default AddSubAssemblyForm;
